import React from 'react'
import {FaLinkedin} from 'react-icons/fa'
import {FaGithub} from 'react-icons/fa'
import { FaTelegram } from 'react-icons/fa'


const HeaderSocial = () => {
  return (
    <div className='header__social'>
        <a href="https://linkedin.com" target='_blank' rel="noreferrer"><FaLinkedin/></a>
        <a href="https://github.com" target='_blank' rel="noreferrer"><FaGithub/></a>
        <a href="https://dribble.com" target='_blank' rel="noreferrer"><FaTelegram/></a>
    </div>
  )
}

export default HeaderSocial